export const formatApiKey = (startChar, endChar) => `${startChar}*******${endChar}`;

export const isExpired = expirationDate => {
  if (!expirationDate) {
    return false;
  }

  return new Date() > new Date(expirationDate);
};
